<template>
    <div class="rfq">
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item v-if="searchForm.billId" label="账单编号" label-width="70px">
                        <el-input v-model="searchForm.billId" placeholder="账单编号" size="mini" clearable style="width: 180px" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" label-width="70px">
                        <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="客户订单编号" label-width="100px">
                        <el-input v-model="searchForm.customerOrderId" placeholder="客户订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="下单日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" label-width="70px">
                        <el-select v-model="searchForm.billStatus" placeholder="状态" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-if="!searchForm.billId" label="可对账" value="0"></el-option>
                            <el-option label="对账申请中" value="1"></el-option>
                            <el-option label="对账完成" value="2"></el-option>
                            <el-option label="对账差异" value="3"></el-option>
                            <el-option label="差异确认中" value="4"></el-option>
                            <el-option label="对账驳回" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否结算" label-width="70px">
                        <el-select v-model="searchForm.settlement" placeholder="是否结算" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未结算" value="0"></el-option>
                            <el-option label="已结算" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="需求所属月份" label-width="100px">
                        <el-input v-model="searchForm.demandMonth" placeholder="需求所属月份" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                        ref="dataTable"
                        :key = "updateTable"
                        row-key="id"
                        :data="tableData"
                        v-loading="loading"
                        style="width: 100%"
                        stripe
                        size="mini"
                        :height="tableConfig.height"
                        @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" fixed />
                    <el-table-column prop="billId" label="账单编号" width="200"  />
                    <el-table-column prop="orderNo" label="订单编号" width="200" />
<!--                    <el-table-column prop="demandMonth" label="需求月份" width="200" />-->
                    <el-table-column prop="totalUntaxedPrice" label="未税总价(元)" width="200" />
                    <el-table-column prop="totalPrice" label="含税总价(元)" width="200" />
                    <el-table-column prop="total" label="总价(元)" width="200" />
                    <el-table-column prop="orderTime" label="下单时间" />
                    <el-table-column prop="remark" label="差异说明" />
                    <el-table-column prop="checkResaon" label="驳回说明" />
                    <el-table-column width="100" align="center" prop="orderStatus" label="订单状态">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.orderStatus == 0" size="mini">待下单</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 1" size="mini">预下单</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 2" size="mini">已下单</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 3" size="mini">已发货</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 4" size="mini">已收货</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 5" size="mini">已取消</el-tag>
                            <el-tag v-if="scope.row.orderStatus == 6" size="mini">已驳回</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" prop="billStatus" label="账单状态">
                        <template slot-scope="scope">
                            <el-tag type="info" v-if="scope.row.billStatus == null" size="mini">未申请</el-tag>
                            <el-tag v-if="scope.row.billStatus == 1" size="mini">申请中</el-tag>
                            <el-tag type="success" v-if="scope.row.billStatus == 2" size="mini">已完成</el-tag>
                            <el-tag type="warning" v-if="scope.row.billStatus == 3" size="mini">对账差异</el-tag>
                            <el-tag v-if="scope.row.billStatus == 4" size="mini">异常确认中</el-tag>
                            <el-tag type="warning" v-if="scope.row.billStatus == 5" size="mini">驳回</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" prop="invoiceStatus" label="开票状态">
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.invoiceStatus" size="mini">已开票</el-tag>
                            <el-tag type="info" v-if="!scope.row.invoiceStatus" size="mini">未开票</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" align="right" fixed="right" label="操作">
                        <template slot="header" slot-scope="header">
                            <el-button v-if="selectStatus == 3" type="primary" size="mini" @click="confimDifference()">差异确认</el-button>
                            <el-button v-if="selectStatus == 0 && selectStatus != ''" type="primary" size="mini" @click="requestBill()">对账</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToReviewDetail(scope.row)">子订单</el-button>
                            <el-button type="text" size="mini" @click="handleToContract(scope.row)">详情</el-button>
                            <el-button type="text" size="mini" @click="handleToDeliveryNote(scope.row)">发货单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes, prev, pager, next" v-if="total>0" :total="total"
                                   :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
                                   @current-change="onPageChange" @prev-click="onPageChange" @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            showSearch:false,
            updateTable:"saleTable",
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            reviewVisible: false,
            companys: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchForm: {
                billId: "",
                applicationNo: "",
                orderNo: "",
                customerOrderId: "",
                billStatus: "",
                settlement: "",
                timeDate: "",
                demandMonth: "",
            },
            searchFormStash: {},
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            tableData: [],
            selectData: [],//选中的数据
            selectStatus: "0", //选中的状态
            rules: {
                orderBatch: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' }
                ],
            },
            scrollTop: 0,
            scrollLeft: 0,
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this;
            let cond = { ...this.searchForm };
            if(!this.searchForm.billStatus){
                cond.billStatus = undefined;
            }
            if (this.searchForm.timeDate != "" && this.searchForm.timeDate != null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.selectStatus = this.searchForm.billStatus;
            this.searchFormStash = {...cond};
            this.setSearchForm();
            this.$axios.post("/admin/jcy/settlement/orderBill", {
                cond,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
                _this.loading = false;
            });
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        requestBill() {
            const that = this;
            if (this.selectData.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要对账的订单',
                    duration: 2000
                });
                return;
            }
            this.loading = true;
            this.$axios.post("/admin/jcy/settlement/requestBill", { orderIds: this.selectData.map(it => it['orderId']) })
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header && resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '请求对账成功',
                            type: 'success'
                        });
                        that.fetchData();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.resultMsg
                        });
                    }
                }).finally(() => {
                that.onSearch();
                that.loading = false;
            });
        },
        confimDifference() {
            const that = this;
            if (this.selectData.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择要确认差异的订单',
                    duration: 2000
                });
                return;
            }
            this.loading = true;
            this.$axios.post("/admin/jcy/settlement/billDifConfirm", { orderIds: this.selectData.map(it => it['orderId']) })
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header && resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '请求确认账单差异成功',
                            type: 'success'
                        });
                        that.fetchData();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.resultMsg
                        });
                    }
                }).finally(() => {
                that.onSearch();
                that.loading = false;
            });
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            this.$router.push({
                name: "orderReviewDetail", params:{title:"订单详情",info:row.orderId,id: row.orderId}
            });

        },
        handleToContract(row) {
            let showBtn = (row.status == 1);

            this.$router.push({
                name: "orderContract", params: {title:"订单详情",hide:true,
                    from: "rfq", orderId: row.orderId,
                    name: row.consignee, totalPrice: row.totalPrice, showBtn: showBtn
                }
            })
        },
        handleToDeliveryNote(row) {
            this.$router.push({ name: "jcyDeliveryNote", params: { title:'京采云送货单' }, query: { id: row.orderId } });
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        setSearchForm() {
            // const params = {searchForm : this.searchForm, pageSize: this.pageSize, currentPage: this.currentPage}
            // sessionStorage.setItem("billOrder-" + this.searchForm.billId || this.searchForm.applicationNo, JSON.stringify(params))
        },
        initSearchForm() {
            // const params = sessionStorage.getItem("billOrder-" + this.searchForm.billId || this.searchForm.applicationNo);
            // const obj = JSON.parse(params)
            // if(params){
            //     this.searchForm = obj.searchForm;
            //     this.currentPage = obj.currentPage;
            //     this.pageSize = obj.pageSize;
            // }
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.searchForm.billId = this.$route.query.billId || '';
        this.searchForm.applicationNo = this.$route.query.applicationNo || '';
        this.initSearchForm();
        this.onSearch();
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    watch: {
        '$route.query' (to, from) {
            // to是变化后的路由对象，from是变化前的路由对象
            const prevBillId = from['billId'] || '';
            const nextBillId = to['billId'] || '';
            const prevApplicationNo = from['applicationNo'] || '';
            const nextApplicationNo = to['applicationNo'] || '';
            if (prevBillId !== nextBillId || prevApplicationNo !== nextApplicationNo) {
                this.searchForm.billId = nextBillId;
                this.searchForm.applicationNo = nextApplicationNo;
                this.onSearch();
            }
        }
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }

        sessionStorage.removeItem("params")
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
}
</script>

<style scoped>

</style>
